import { render } from "./FuturesProfitActionNumberWidgetParams.vue?vue&type=template&id=46a65d8e"
import script from "./FuturesProfitActionNumberWidgetParams.vue?vue&type=script&lang=js"
export * from "./FuturesProfitActionNumberWidgetParams.vue?vue&type=script&lang=js"
script.render = render

export default script